<template>
  <div class="kpb-text" v-html="data.content" :style="style"></div>
</template>

<script>
/** Component for rendering rich text */
export default {
  props: {
    data: Object,
    textAlign: {
      type: String,
      default: 'start',
      validator: val => ['start', 'center', 'end'].includes(val),
    },
    lineHeight: {
      type: Number,
    },
    wordBreak: {
      type: String,
      default: 'break-word',
    },
  },
  computed: {
    style() {
      let base = {
        '--kpb-text-text-align': this.textAlign,
        '--kpb-text-word-break': this.wordBreak,
      }
      if (this.lineHeight) base['--kpb-text-text-line-height'] = this.lineHeight
      return base
    },
  },
}
</script>

<style lang="scss">
.kpb-text {
  word-break: var(--kpb-text-word-break);
  line-height: var(--kpb-text-text-line-height);
  text-align: var(--kpb-text-text-align);

  ol li,
  ul li {
    word-break: var(--kpb-text-word-break);
  }

  p:last-child {
    margin-block-end: 0em;
  }
}
</style>
